<!-- VARIANT: HERO — Bloc complet glassmorphism pour sections principales -->
@if (variant() === 'hero') {
<div class="relative overflow-hidden bg-white/5 backdrop-blur-md border border-[#eac639]/30 rounded-2xl p-6 md:p-8 my-8">
  <!-- Subtle gold gradient background -->
  <div class="absolute inset-0 bg-gradient-to-br from-[#eac639]/10 via-transparent to-[#00c4ff]/5 pointer-events-none"></div>
  
  <div class="relative flex flex-col md:flex-row items-start md:items-center gap-6">
    <!-- Icon -->
    <div class="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-xl bg-[#eac639]/15 border border-[#eac639]/30">
      <span class="text-3xl">🏛️</span>
    </div>
    
    <!-- Content -->
    <div class="flex-1">
      <div class="flex flex-wrap items-center gap-3 mb-2">
        <h3 class="text-lg md:text-xl font-bold text-[#eac639] m-0">Agrément Crédit Impôt Innovation</h3>
        <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-[#eac639]/20 text-[#eac639] border border-[#eac639]/30">
          N°29987181
        </span>
      </div>
      <p class="text-sm md:text-base text-gray-300 mb-3 leading-relaxed">
        Délivré par la <strong class="text-white">DRIEETS Île-de-France</strong> — Valable <strong class="text-white">2026 à 2030</strong>
      </p>
      <p class="text-sm md:text-base text-gray-400 m-0 leading-relaxed">
        Les PME et startups qui font appel à Mesh Box peuvent bénéficier d'un 
        <strong class="text-[#eac639]">crédit d'impôt de 20%</strong> sur leurs dépenses d'innovation
        <span class="text-gray-500">(jusqu'à 60% dans les DOM-TOM)</span>.
      </p>
      <a href="/assets/attestation-cii-29987181.pdf" target="_blank" rel="noopener"
         class="relative z-10 inline-flex items-center gap-2 mt-4 text-sm font-medium text-[#eac639] hover:text-[#ffd94a] hover:underline transition-colors cursor-pointer"
         style="pointer-events: auto; text-decoration: underline;">
        <span>📄</span> Consulter l'attestation officielle (PDF)
      </a>
    </div>
  </div>
</div>
}

<!-- VARIANT: INLINE — Ligne dorée pour cards et sections de pages -->
@if (variant() === 'inline') {
<div class="flex items-center gap-3 bg-[#eac639]/10 border border-[#eac639]/25 rounded-xl px-4 py-3 my-4 backdrop-blur-sm">
  <span class="flex-shrink-0 text-xl">🏛️</span>
  <p class="text-sm text-gray-300 m-0 leading-snug">
    <strong class="text-[#eac639]">Éligible Crédit Impôt Innovation</strong> — 
    Déduisez jusqu'à 20% de vos dépenses d'innovation · Agrément CII n°29987181 (2026–2030)
  </p>
</div>
}

<!-- VARIANT: COMPACT — Petit badge pilule pour footer, header, formulaires -->
@if (variant() === 'compact') {
<div class="inline-flex items-center gap-2 bg-[#eac639]/10 border border-[#eac639]/20 rounded-full px-3 py-1.5 backdrop-blur-sm">
  <span class="text-sm">🏛️</span>
  <span class="text-xs font-medium text-[#eac639]">Agréé CII n°29987181 (2026–2030)</span>
</div>
}

<!-- VARIANT: TABLE — Tableau comparatif des taux CII par région -->
@if (variant() === 'table') {
<div class="relative overflow-hidden bg-white/5 backdrop-blur-md border border-[#eac639]/30 rounded-2xl p-6 md:p-8 my-8">
  <div class="absolute inset-0 bg-gradient-to-br from-[#eac639]/10 via-transparent to-[#00c4ff]/5 pointer-events-none"></div>

  <div class="relative">
    <!-- Header -->
    <div class="flex flex-wrap items-center gap-3 mb-2">
      <h3 class="text-lg md:text-xl font-bold text-[#eac639] m-0">🏛️ Crédit Impôt Innovation — Taux par région</h3>
      <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-[#eac639]/20 text-[#eac639] border border-[#eac639]/30">
        Agrément n°29987181
      </span>
    </div>
    <p class="text-sm text-gray-400 mb-6">
      Mesh Box est agréé CII (2026–2030). Le taux de crédit d'impôt dépend de la localisation de <strong class="text-white">votre entreprise</strong>, pas de la nôtre.
    </p>

    <!-- Tableau responsive -->
    <div class="overflow-x-auto">
      <table class="w-full border-collapse text-sm md:text-base">
        <thead>
          <tr class="border-b border-white/10">
            <th class="text-left py-3 px-4 text-gray-400 font-semibold">Localisation</th>
            <th class="text-center py-3 px-4 text-gray-400 font-semibold">Taux CII</th>
            <th class="text-right py-3 px-4 text-gray-400 font-semibold">Plafond / an</th>
          </tr>
        </thead>
        <tbody>
          <!-- Métropole — ligne mise en évidence -->
          <tr class="bg-[#eac639]/10 border border-[#eac639]/30 rounded-lg">
            <td class="py-4 px-4 rounded-l-lg">
              <div class="flex flex-col gap-1">
                <span class="font-semibold text-white">🇫🇷 France métropolitaine</span>
                <span class="inline-flex items-center gap-1 w-fit px-2 py-0.5 rounded-full text-[10px] font-bold bg-[#eac639]/20 text-[#eac639] border border-[#eac639]/30">
                  ✅ Votre cas le plus fréquent
                </span>
              </div>
            </td>
            <td class="py-4 px-4 text-center">
              <span class="text-2xl font-bold text-[#eac639]">20%</span>
            </td>
            <td class="py-4 px-4 text-right rounded-r-lg">
              <span class="font-semibold text-white">80 000 €</span>
            </td>
          </tr>
          <!-- Corse -->
          <tr class="border-b border-white/5">
            <td class="py-4 px-4">
              <span class="font-medium text-gray-300">🏝️ Corse</span>
            </td>
            <td class="py-4 px-4 text-center">
              <span class="font-semibold text-gray-200">35 à 40%</span>
              <span class="block text-[10px] text-gray-500 mt-0.5">selon taille entreprise</span>
            </td>
            <td class="py-4 px-4 text-right">
              <span class="font-medium text-gray-300">140 000 – 160 000 €</span>
            </td>
          </tr>
          <!-- DOM-TOM -->
          <tr>
            <td class="py-4 px-4">
              <span class="font-medium text-gray-300">🌴 DOM-TOM</span>
            </td>
            <td class="py-4 px-4 text-center">
              <span class="font-semibold text-gray-200">60%</span>
            </td>
            <td class="py-4 px-4 text-right">
              <span class="font-medium text-gray-300">240 000 €</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Note légale + lien attestation -->
    <div class="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <p class="text-xs text-gray-500 m-0 leading-relaxed max-w-xl">
        Taux applicables aux dépenses exposées à compter du 1<sup>er</sup> janvier 2025 
        (Loi de finances 2025, art. 56). Source : <span class="text-gray-400">BOFIP</span>.
        Le plafond s'applique aux dépenses éligibles par année civile.
      </p>
      <a href="/assets/attestation-cii-29987181.pdf" target="_blank" rel="noopener"
         class="relative z-10 inline-flex items-center gap-2 text-sm font-medium text-[#eac639] hover:text-[#ffd94a] hover:underline transition-colors cursor-pointer flex-shrink-0"
         style="pointer-events: auto; text-decoration: underline;">
        <span>📄</span> Attestation officielle (PDF)
      </a>
    </div>
  </div>
</div>
}
